import { EXPERIENCE_LEVELS } from "lookup";

const PROFILE_FONT = "font-inter";
const PROFILE_TEXT = "text-slate-700";
const PROFILE_TEXT_MUTED = "text-gray-500";

/** Shared typography tokens for the talent profile card. */
export const PROFILE_TEXT_XS = `${PROFILE_FONT} text-xs font-normal ${PROFILE_TEXT}`;
export const PROFILE_TEXT_SM = `${PROFILE_FONT} text-sm font-normal ${PROFILE_TEXT}`;
export const PROFILE_TEXT_SM_MUTED = `${PROFILE_FONT} text-sm font-normal ${PROFILE_TEXT_MUTED}`;
export const PROFILE_TEXT_SM_MEDIUM = `${PROFILE_FONT} text-sm font-medium ${PROFILE_TEXT}`;
export const PROFILE_TEXT_BASE = `${PROFILE_FONT} text-base font-normal ${PROFILE_TEXT}`;
export const PROFILE_TEXT_BASE_MUTED = `${PROFILE_FONT} text-base font-normal ${PROFILE_TEXT_MUTED}`;
export const PROFILE_TEXT_BASE_MEDIUM = `${PROFILE_FONT} text-base font-medium ${PROFILE_TEXT}`;

export const PROFILE_SECTION_TITLE_CLASSNAME = [
  PROFILE_TEXT_BASE_MEDIUM,
  "leading-normal tracking-normal",
  "[font-feature-settings:'liga'_off,'clig'_off]",
  "[leading-trim:both]",
  "[text-edge:cap]",
].join(" ");

export const PROFILE_MORE_LINK_CLASSNAME = [
  "mt-3 flex w-full items-center justify-center gap-1",
  PROFILE_TEXT_SM_MEDIUM,
  "transition hover:text-slate-900 hover:underline",
].join(" ");

export const PROFILE_MORE_LINK_COUNT_CLASSNAME = PROFILE_TEXT_XS;

export const PROFILE_META_LINE_CLASSNAME = PROFILE_TEXT_SM;

export const PROFILE_CAREER_TITLE_CLASSNAME = PROFILE_TEXT_BASE_MEDIUM;

export const PROFILE_CAREER_META_CLASSNAME = PROFILE_TEXT_BASE_MUTED;

export const PROFILE_CAREER_DESCRIPTION_CLASSNAME = PROFILE_TEXT_SM_MUTED;

export const PROFILE_PANEL_CLASSNAME = [
  "rounded-lg bg-surface p-[18px]",
  PROFILE_TEXT_SM,
].join(" ");

// Canonical values from lookup.js EXPERIENCE_LEVELS (low / medium / high).
export const ExperienceLevels = Object.freeze(
  Object.fromEntries(
    EXPERIENCE_LEVELS.map(({ value }) => [value.toUpperCase(), value])
  )
);

// Matches platform-frontend Experience Timeline skill badges
// (TimelineSideCard): Expert / Intermediate / Beginner.
export const EXPERIENCE_LABELS = {
  [ExperienceLevels.HIGH]: "Expert",
  [ExperienceLevels.MEDIUM]: "Intermediate",
  [ExperienceLevels.LOW]: "Beginner",
};

export const EXPERIENCE_SORT_ORDER = Object.fromEntries(
  EXPERIENCE_LEVELS.map(({ value }, index) => [
    value,
    EXPERIENCE_LEVELS.length - 1 - index,
  ])
);

export const normalizeExperienceLevel = (experience) => {
  if (!experience) {
    return null;
  }

  const normalized = experience.toLowerCase();

  if (Object.values(ExperienceLevels).includes(normalized)) {
    return normalized;
  }

  return null;
};

export const getExperienceSortRank = (experience) => {
  const level = normalizeExperienceLevel(experience);

  if (!level) {
    return EXPERIENCE_LEVELS.length;
  }

  return EXPERIENCE_SORT_ORDER[level];
};

export const sortSkillsByExperience = (skills) =>
  [...skills].sort((a, b) => {
    const rankDiff =
      getExperienceSortRank(a.experience) - getExperienceSortRank(b.experience);

    if (rankDiff !== 0) {
      return rankDiff;
    }

    return (a.name || "").localeCompare(b.name || "");
  });
